import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider, Spin } from 'antd';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import './index.css';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { router } from './routes';

import './index.css';
import './index.module.scss';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// Create emotion cache with higher specificity than antd
const emotionCache = createCache({
  key: 'css',
  prepend: false, // This ensures emotion styles come after antd styles
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#0c55e4',
        },
      }}
    >
      <CacheProvider value={emotionCache}>
        <QueryClientProvider client={queryClient}>
          <Suspense fallback={<Spin size="small" />}>
            <RouterProvider router={router} />
          </Suspense>
          {import.meta.env.VITE_NODE_ENV === 'develop' && <ReactQueryDevtools initialIsOpen={false} />}
        </QueryClientProvider>
      </CacheProvider>
    </ConfigProvider>
  </StrictMode>,
);
